export default __webpack_public_path__ + "5bb40c600aa80099051576100a74b82f.png";